// extracted by mini-css-extract-plugin
export default {"Header":"Footer_Header__uUWM8","Main":"Footer_Main__BjbTn","Footer":"Footer_Footer__bTGiE"};